import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalBody,
    Flex,
    ModalContent,
    ModalFooter,
    Input,
    Button,
} from '@chakra-ui/react';
import ZaraButton from '../custom-components/buttons/Button';

const AddUrl = ({ isOpen, onClose, value, setValue, loadUrl, refetchFrequency = 'none', setRefetchFrequency = (v) => {} }) => {
    const freqOptions = [
        { key: 'none', label: 'Never' },
        { key: 'daily', label: 'Daily' },
        { key: 'weekly', label: 'Weekly' },
        { key: 'monthly', label: 'Monthly' },
        { key: 'yearly', label: 'Yearly' },
    ];
    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose} motionPreset='slideInBottom' size='xl'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader className='tracking-tight font-bold text-[#050536]' fontSize='2xl'>
                    Fetch URL for Knowledge Base{' '}
                </ModalHeader>
                <ModalBody>
                    <Input
                        placeholder='Enter URL to fetch...'
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    />

                    <Flex mt='3' direction='column' gap='2'>
                        <div className='text-sm text-gray-600'>Refetch Frequency</div>
                        <Flex gap='2' wrap='wrap'>
                            {freqOptions.map(opt => (
                                <Button
                                    key={opt.key}
                                    size='sm'
                                    variant={refetchFrequency === opt.key ? 'solid' : 'outline'}
                                    onClick={() => setRefetchFrequency(opt.key)}
                                >
                                    {opt.label}
                                </Button>
                            ))}
                        </Flex>
                    </Flex>
                </ModalBody>
                <ModalFooter p='16px 24px'>
                    <Flex alignItems='center' justifyContent='space-between' w='100%'>
                        <Button
                            onClick={() => {
                                setValue('');
                                onClose();
                            }}
                            variant='outline'
                            fontSize='sm'
                        >
                            Cancel
                        </Button>
                        <ZaraButton
                            isDisabled={!value.trim()}
                            onClick={() => {
                                loadUrl(value);
                                onClose();
                                setValue('');
                            }}
                            w='auto'
                            fontSize='sm'
                        >
                            Fetch URL
                        </ZaraButton>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default AddUrl;
